import { tw } from "@careinfo/tailwind";
import { useFormContext } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import MultiSelectField from "../../shared/MultiSelectField";
import TextField from "../../shared/TextField";
import { IPage } from "../../types/interface";

export default function PageForm() {
  const { control } = useFormContext<IPage>();

  return (
    <>
      <div className={tw`grid grid-cols-2 gap-4`}>
        <TextField
          control={control}
          name="title"
          placeholder="Enter title of page"
          label="Title"
        />
        <TextField
          control={control}
          name="description"
          placeholder="Enter Description for page"
          label="Description"
        />
        <MultiSelectField
          control={control}
          name="popup_pages"
          url={APIS.PAGE}
          queryKey="Page"
          params={{ is_popup: true }}
          label="Popup pages"
          dataLabel="title"
        />
      </div>
    </>
  );
}
